"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasePricingOperation = void 0;
var BasePricingOperation = /** @class */ (function () {
    function BasePricingOperation(_a) {
        var article = _a.article, strategyToUse = _a.strategy, bulkSettings = _a.bulkSettings, priceFloor = _a.priceFloor, priceCeiling = _a.priceCeiling, currency = _a.currency, gameSettings = _a.gameSettings;
        this.article = article;
        this.strategy = strategyToUse;
        this.bulkSettings = bulkSettings;
        this.priceFloor = priceFloor;
        this.priceCeiling = priceCeiling;
        this.currency = currency;
        this.gameSettings = gameSettings;
    }
    Object.defineProperty(BasePricingOperation.prototype, "priceAttribute", {
        get: function () {
            return this.currency === 'GBP' ? 'priceGBP' : 'price';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePricingOperation.prototype, "playsetModifier", {
        get: function () {
            if (this.article.isPlayset) {
                return this.gameSettings.playsetCount;
            }
            else {
                return 1;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePricingOperation.prototype, "idGame", {
        get: function () {
            return this.gameSettings.idGame;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePricingOperation.prototype, "bulkValue", {
        get: function () {
            var bulkPrices = this.bulkSettings[this.article.card.rarity];
            if (this.article.isShiny && bulkPrices['foilPrice'])
                return bulkPrices['foilPrice'];
            else
                return bulkPrices['price'];
        },
        enumerable: false,
        configurable: true
    });
    BasePricingOperation.prototype.playsetCoefficient = function (targetArticlePlayset) {
        if (this.article.isPlayset === targetArticlePlayset)
            return 1;
        else if (this.article.isPlayset > targetArticlePlayset)
            return this.gameSettings.playsetCount;
        else
            return 1 / this.gameSettings.playsetCount;
    };
    BasePricingOperation.prototype.getNewPrice = function (basePrice) {
        var newPrice = basePrice;
        var usedBulkPrice = false;
        var hitDecreaseCap = false;
        var hitIncreaseCap = false;
        if (this.strategy.modifier.kind === 'number') {
            newPrice = Math.round(newPrice * 100 - this.strategy.modifier.value) / 100;
        }
        else if (this.strategy.modifier.kind === 'percent') {
            newPrice = Math.round(newPrice * this.strategy.modifier.value) / 100;
        }
        newPrice = Math.max(newPrice, 0.02);
        if (this.priceCeiling && newPrice > this.priceCeiling) {
            newPrice = this.priceCeiling;
            hitIncreaseCap = true;
        }
        if (this.priceFloor && this.priceFloor > newPrice) {
            newPrice = this.priceFloor;
            hitDecreaseCap = true;
            hitIncreaseCap = false;
        }
        if (this.strategy.bulkSettingsId[this.idGame] && this.bulkValue > newPrice) {
            newPrice = this.bulkValue;
            usedBulkPrice = true;
            hitIncreaseCap = false;
        }
        return { newPrice: newPrice, usedBulkPrice: usedBulkPrice, hitDecreaseCap: hitDecreaseCap, hitIncreaseCap: hitIncreaseCap };
    };
    return BasePricingOperation;
}());
exports.BasePricingOperation = BasePricingOperation;
//# sourceMappingURL=basePricingOperation.js.map